import React, { Component, useState, Fragment } from "react";
import { connect } from "react-redux";

//-- Material
import { withStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import { userActions, categoryActions } from "../../../_actions";
import { apiConstants } from "../../../_constants/api.constants";
import DatePicker from "react-datepicker";
import MultiSelect from "react-multi-select-component";
import Grid from '@material-ui/core/Grid';
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';

// import MomentUtils from "@date-io/moment";
// import {
//   MuiPickersUtilsProvider,
//   TimePicker,
//   DatePicker
// } from "material-ui-pickers";

// import { DatePicker } from "@material-ui/pickers";

//-- CSS for Material
const styles = theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
    backgroundColor: "#269abc"
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey
  },
  contentRoot: {
    padding: theme.spacing(2),
    fontSize: 14,
    width: 600
  },
  actionRoot: {
    margin: 0,
    padding: theme.spacing(1)
  }
});

const DialogTitle = withStyles(styles)(props => {
  const { children, classes, onClose } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles(styles)(props => {
  const { children, classes } = props;
  return (
    <MuiDialogContent dividers className={classes.contentRoot}>
      {children}
    </MuiDialogContent>
  );
});

const DialogActions = withStyles(styles)(props => {
  const { children } = props;
  return <MuiDialogActions>{children}</MuiDialogActions>;
});

// const [selectedDate, setSelectedDate] = new Date('2014-08-18T21:11:54');

// const handleDateChange = date => {
//   setSelectedDate(date);
// };

class EditPopup extends Component {
  constructor(props) {
    super(props);

    this.state = {
      defaultData: {},
      validated: { errors: { coupon_token: "", coupon_title: "", description: "" } },
      selectedDate: '',
      couponStatus: true,
      allActiveCat: [],
      selectedCat: [],
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    //this.handleDateChange = this.handleDateChange.bind(this);
    // this.BasicDatePicker=this.BasicDatePicker.bind(this);
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(categoryActions.getAllActiveCategory(apiConstants.GET_ALL_CATEGORIES_SUB_CATEGORIES));
  }

  /*
   * componentWillReceiveProps - Whenever Props change, it will call and store data
   * update the state values with new props values, this method will get called whenever any change happens to props values
   */
  componentWillReceiveProps(props) {
    const { defaultData, userData } = props;
    this.setState({
      defaultData
    });


    if (
      userData !== undefined &&
      props.popupType !== 'AddCoupon' &&
      userData.categories !== undefined &&
      userData.categories.length > 0) {
      var allSelectedCat = [];
      userData.categories.map((cat) => {
        let catObj = {};
        catObj.label = cat.categoryTitle;
        catObj.value = cat._id;

        allSelectedCat.push(catObj);
      });
      this.setState({ selectedCat: allSelectedCat });
    }

    if (props.popupType === 'AddCoupon') {
      this.setState({ defaultData: {}, selectedDate: '' })

    }
    if (!props.editOpen) {
      this.setState({
        validated: { errors: { coupon_token: "", coupon_title: "", description: "" } }
      });
    }

    if (props.popupType !== 'AddCoupon' && props.userData) {
      let statusData = '';
      if (props.userData.status === 'active') { statusData = true }
      else { statusData = false }

      var d = Date.parse(props.userData.expiry);
      this.setState({ defaultData: props.userData });
      this.setState({ couponStatus: statusData, selectedDate: d });
    }

    if (props.getAllActiveCat !== undefined &&
      props.getAllActiveCat.activeCat !== undefined &&
      props.getAllActiveCat.activeCat.data !== undefined &&
      props.getAllActiveCat.activeCat.data.data) {

      if (props.getAllActiveCat.activeCat.data.data.length > 0) {
        var allCat = [];
        props.getAllActiveCat.activeCat.data.data.map((cat) => {
          let catObj = {};
          catObj.label = cat.categoryTitle;
          catObj.value = cat._id;

          allCat.push(catObj);
        });

        this.setState({ allActiveCat: allCat });

      }
    }
  }

  handleValidation() {
    const { siteConstants } = this.props.language;

    const fields = this.state.defaultData;
    let formIsValid = true;

    if (fields.coupon_token === undefined || fields.coupon_token === "") {
      this.setState({
        validated: {
          errors: { coupon_token: siteConstants.ERR_CAN_NOT_BLANK }
        }
      });
      formIsValid = false;
      return false;
    }

    if (fields.coupon_title === undefined || fields.coupon_title === "") {
      this.setState({
        validated: {
          errors: { coupon_title: siteConstants.ERR_CAN_NOT_BLANK }
        }
      });
      formIsValid = false;
      return false;
    }
    if (fields.description === undefined || fields.description == "") {
      this.setState({
        validated: {
          errors: { description: siteConstants.ERR_CAN_NOT_BLANK }
        }
      });
      formIsValid = false;
      return false;
    }

    if (fields.couponType === undefined || fields.couponType == "") {
      this.setState({
        validated: {
          errors: { couponType: siteConstants.ERR_CAN_NOT_BLANK }
        }
      });
      formIsValid = false;
      return false;
    }

    if (fields.couponValue === undefined || fields.couponValue == "") {
      this.setState({
        validated: {
          errors: { couponValue: siteConstants.ERR_CAN_NOT_BLANK }
        }
      });
      formIsValid = false;
      return false;
    }

    if (fields.productMinPrice === undefined || fields.productMinPrice == "") {
      this.setState({
        validated: {
          errors: { productMinPrice: siteConstants.ERR_CAN_NOT_BLANK }
        }
      });
      formIsValid = false;
      return false;
    }

    if (this.state.selectedCat.length === 0) {
      this.setState({
        validated: {
          errors: { selectedCat: siteConstants.ERR_CAN_NOT_BLANK }
        }
      });
      formIsValid = false;
      return false;
    }



    if (this.state.selectedDate === undefined || this.state.selectedDate == "") {
      this.setState({
        validated: {
          errors: { selectedDate: siteConstants.ERR_CAN_NOT_BLANK }
        }
      });
      formIsValid = false;
      return false;
    }



    return formIsValid;


  }

  makeid(length) {
    var result = "";
    var characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  handleSubmit = e => {
    e.preventDefault();

    // let token;
    // require('crypto').randomBytes(8, function(err, buffer) {
    //    token = buffer.toString('hex');    
    // });

    if (this.handleValidation()) {
      //let couponToken = this.makeid(8);
      let obj = {};
      obj.page = this.props.currentPage;
      obj.orderBy = "id";
      obj.orderByAscDesc = "ASC";
      obj.perPage = 10;



      let postData = {};
      postData.title = this.state.defaultData.coupon_title;
      postData.description = this.state.defaultData.description;
      postData.couponType = this.state.defaultData.couponType;
      postData.couponValue = this.state.defaultData.couponValue;
      postData.minProductPrice = this.state.defaultData.productMinPrice;
      postData.selectedCategories = this.state.selectedCat;
      postData.expiry_date = this.state.selectedDate;
      postData.couponToken = this.state.defaultData.coupon_token;

      var userId = JSON.parse(sessionStorage.getItem("user"))._id;
      var role = JSON.parse(sessionStorage.getItem("user")).role_type;
      if (role[0] === 'shopkeeper') {
        postData.shopkeeperId = userId;
        obj.shopkeeperId = userId;
      }

      this.props.dispatch(
        userActions.addCoupon(
          apiConstants.ADD_COUPON,
          postData,
          apiConstants.GET_COUPOUN,
          obj
        )
      );

      this.props.funPopupClose("editOpen");
    } else {
      //alert("Form has errors.")
    }
  };

  handleUpdate = e => {
    e.preventDefault();

    if (this.handleValidation()) {
      let obj = {};
      obj.page = this.props.currentPage;
      obj.orderBy = "id";
      obj.orderByAscDesc = "ASC";
      obj.perPage = 10;

      let statusValue = "active";

      if (this.state.couponStatus === true) {
        statusValue = "active";
      } else {
        statusValue = "pending";
      }

      let postData = {};
      postData.id = this.state.defaultData._id;
      postData.title = this.state.defaultData.coupon_title;
      postData.description = this.state.defaultData.description;
      postData.couponType = this.state.defaultData.couponType;
      postData.couponValue = this.state.defaultData.couponValue;
      postData.minProductPrice = this.state.defaultData.productMinPrice;
      postData.selectedCategories = this.state.selectedCat;
      postData.expiry_date = this.state.selectedDate;
      postData.status = statusValue;
      postData.couponToken = this.state.defaultData.coupon_token;

      var userId = JSON.parse(sessionStorage.getItem("user"))._id;
      var role = JSON.parse(sessionStorage.getItem("user")).role_type;
      if (role[0] === 'shopkeeper') { postData.shopkeeperId = userId; obj.shopkeeperId = userId; }

      this.props.dispatch(
        userActions.updateCoupon(
          apiConstants.EDIT_COUPON,
          postData,
          apiConstants.GET_COUPOUN,
          obj
        )
      );

      this.props.funPopupClose("editOpen");
    } else {
      //alert("Form has errors.")
    }
  };

  /*
   *   we are setting the Values
   */
  handleChange = e => {
    const { name, value } = e.target;
    const { defaultData } = this.state;
    this.setState({
      defaultData: {
        ...defaultData,
        [name]: value
      }
    });
  };

  handleDateChange = date => {
    this.setState({
      selectedDate: date
    });
  }

  handleStatusChange(e) {
    this.setState({ couponStatus: e.target.checked });
  }


  //category multipicker callback
  changeCategory = (e) => {
    this.setState({ selectedCat: e });
  }

  render() {
    const { siteConstants } = this.props.language;
    let popupType = this.props.popupType;
    if (popupType === "EditCoupon") {
      let addEditTitle = siteConstants.LABEL_EDIT_NOTICES;
      if (this.props.addButton) addEditTitle = siteConstants.LABEL_EDIT_NOTICES;

      let d = new Date(this.state.defaultData.expiry);
      let expiryDate = d.toISOString();
      //-- Popup will open on notices page for add/edit the NOTICES
      return (
        <Dialog
          onClose={() => this.props.funPopupClose("editOpen")}
          aria-labelledby="customized-dialog-title"
          open={this.props.editOpen}
        >
          <DialogTitle
            id="customized-dialog-title"
            className="editTitle"
            onClose={() => this.props.funPopupClose("editOpen")}
          >
            {addEditTitle}
          </DialogTitle>
          <DialogContent>
            <div className="row">
              <div className="col-lg-12">
                <div className="panel panel-default">
                  <div className="panel-body">
                    <div className="row">
                      <div className="col">
                        <form role="form">
                          <div className="col-lg-12 mt-3">
                            <div className="form-group">
                              <label>{siteConstants.GEN_COUPON_TOKEN}</label>
                              <input
                                className="form-control"
                                name="coupon_token"
                                placeholder={siteConstants.GEN_COUPON_TOKEN}
                                value={this.state.defaultData.coupon_token}
                                onChange={this.handleChange}
                              />
                              <span className="my-error">
                                {this.state.validated.errors.coupon_token}
                              </span>
                            </div>
                          </div>
                          <div className="col-lg-12 mt-3">
                            <div className="form-group">
                              <label>{siteConstants.GEN_TITLE}</label>
                              <input
                                className="form-control"
                                name="coupon_title"
                                placeholder={siteConstants.GEN_TITLE}
                                value={this.state.defaultData.coupon_title}
                                onChange={this.handleChange}
                              />
                              <span className="my-error">
                                {this.state.validated.errors.coupon_title}
                              </span>
                            </div>
                          </div>
                          <div className="col-lg-12">
                            <div className="form-group">
                              <label>{siteConstants.GEN_DESCRIPTION}</label>
                              <textarea
                                className="form-control"
                                placeholder={siteConstants.GEN_DESCRIPTION}
                                name="description"
                                onChange={this.handleChange}
                                value={this.state.defaultData.description}
                              ></textarea>
                              <span className="my-error">
                                {this.state.validated.errors.description}
                              </span>
                            </div>
                          </div>

                          <div className="col-lg-12">
                            <div className="form-group">
                              <label>{siteConstants.LABEL_PROMO_TYPE}</label>

                              <select
                                className="form-control"
                                name="couponType"
                                onChange={this.handleChange}
                                defaultValue={this.state.defaultData.couponType}
                              >
                                <option></option>
                                <option value="flat">Flat</option>
                                <option value="Percent">Percent</option>
                              </select>

                              <span className="my-error">
                                {this.state.validated.errors.couponType}
                              </span>
                            </div>
                          </div>

                          <div className="col-lg-12">
                            <div className="form-group">
                              <label>{siteConstants.LABEL_PROMO_VALUE}</label>

                              <input
                                type="number"
                                min="0"
                                onChange={this.handleChange}
                                placeholder={siteConstants.LABEL_PROMO_VALUE}
                                className="form-control"
                                name="couponValue"
                                value={this.state.defaultData.couponValue}
                              />

                              <span className="my-error">
                                {this.state.validated.errors.couponValue}
                              </span>
                            </div>
                          </div>

                          <div className="col-lg-12 mt-4">
                            <div className="form-group">
                              <div className="row">
                                <div className="col-lg-6">
                                  <label>{siteConstants.LABEL_MINIMUM_VALUE}</label>

                                  <input
                                    type="number"
                                    min="0"
                                    onChange={this.handleChange}
                                    placeholder={siteConstants.LABEL_MINIMUM_VALUE}
                                    className="form-control"
                                    name="productMinPrice"
                                    value={this.state.defaultData.productMinPrice}
                                  />

                                  <span className="my-error">
                                    {this.state.validated.errors.productMinPrice}
                                  </span>
                                </div>

                                <div className="col-lg-6">
                                  <div className="form-group">
                                    <label>{siteConstants.LABEL_PRODUCT_CATEGORY}</label>

                                    <MultiSelect
                                      options={this.state.allActiveCat}
                                      value={this.state.selectedCat}
                                      onChange={(e) => this.changeCategory(e)}
                                      labelledBy={"Select"}

                                    />
                                    <span className="my-error">
                                      {this.state.validated.errors.selectedCat}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>




                          <div className="col-lg-12 mt-4">
                            <div className="form-group">
                              <div className="row">
                                <div className="col-lg-6">
                                  <label>{siteConstants.GEN_EXPIRY_DATE}</label>
                                  <br />
                                  <DatePicker
                                    selected={this.state.selectedDate}
                                    onChange={this.handleDateChange}
                                    className="form-control"
                                    popperPlacement='top-start'
                                  /></div>

                                <div className="col-lg-6">
                                  <div className="form-group">
                                    <label>{siteConstants.LABEL_STATUS}</label>
                                    <div className="custom-control custom-checkbox small">
                                      <input
                                        type="checkbox"
                                        className="form-check-input"
                                        htmlFor="customCheck"
                                        id="customCheck"
                                        name="status"
                                        checked={this.state.couponStatus}
                                        onChange={e => this.handleStatusChange(e)}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="col-lg-12">
                            <div className="form-group">
                              <button
                                type="button"
                                className="btn btn-primary"
                                onClick={this.handleUpdate}
                              >
                                {siteConstants.BTN_SAVE}
                              </button>
                              &nbsp;
                              <button
                                type="button"
                                className="btn btn-info"
                                onClick={() =>
                                  this.props.funPopupClose("editOpen")
                                }
                              >
                                {siteConstants.BTN_CANCEL}
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </DialogContent>
        </Dialog>
      );
    } else if (popupType === "AddCoupon") {
      //-- check Add/Edit label
      let addEditTitle = siteConstants.LABEL_ADD_NOTICES;
      if (this.props.addButton)
        addEditTitle = siteConstants.LABEL_ADD_NOTICES;

      //-- Popup will open on notices page for add/edit the Advertisment
      return (
        <Dialog
          onClose={() => this.props.funPopupClose("editOpen")}
          aria-labelledby="customized-dialog-title"
          open={this.props.editOpen}
        >
          <DialogTitle
            id="customized-dialog-title"
            onClose={() => this.props.funPopupClose("editOpen")}
            className="editTitle"
          >
            {/* <p className="editTitleTag">{addEditTitle}</p> */}
            {addEditTitle}
          </DialogTitle>
          <DialogContent>
            <div className="row">
              <div className="col-lg-12">
                <div className="panel panel-default">
                  <div className="panel-body">
                    <div className="row">
                      <div className="col">
                        <form role="form">
                          <div className="col-lg-12 mt-3">
                            <div className="form-group">
                              <label>{siteConstants.GEN_COUPON_TOKEN}</label>
                              <input
                                className="form-control"
                                name="coupon_token"
                                placeholder={siteConstants.GEN_COUPON_TOKEN}
                                value={this.state.defaultData.coupon_token}
                                onChange={this.handleChange}
                              />
                              <span className="my-error">
                                {this.state.validated.errors.coupon_token}
                              </span>
                            </div>
                          </div>
                          <div className="col-lg-12 mt-3">
                            <div className="form-group">
                              <label>{siteConstants.GEN_TITLE}</label>
                              <input
                                className="form-control"
                                name="coupon_title"
                                placeholder={siteConstants.GEN_TITLE}
                                value={this.state.defaultData.coupon_title}
                                onChange={this.handleChange}
                              />
                              <span className="my-error">
                                {this.state.validated.errors.coupon_title}
                              </span>
                            </div>
                          </div>
                          <div className="col-lg-12">
                            <div className="form-group">
                              <label>{siteConstants.GEN_DESCRIPTION}</label>
                              <textarea
                                className="form-control"
                                placeholder={siteConstants.GEN_DESCRIPTION}
                                name="description"
                                onChange={this.handleChange}
                              >
                                {this.state.defaultData.description}
                              </textarea>
                              <span className="my-error">
                                {this.state.validated.errors.description}
                              </span>
                            </div>
                          </div>

                          <div className="col-lg-12">
                            <div className="form-group">
                              <label>{siteConstants.LABEL_PROMO_TYPE}</label>

                              <select
                                className="form-control"
                                name="couponType"
                                onChange={this.handleChange}
                              >
                                <option></option>
                                <option value="flat">Flat</option>
                                <option value="Percent">Percent</option>
                              </select>

                              <span className="my-error">
                                {this.state.validated.errors.couponType}
                              </span>
                            </div>
                          </div>

                          <div className="col-lg-12">
                            <div className="form-group">
                              <label>{siteConstants.LABEL_PROMO_VALUE}</label>

                              <input
                                type="number"
                                min="0"
                                onChange={this.handleChange}
                                placeholder={siteConstants.LABEL_PROMO_VALUE}
                                className="form-control"
                                name="couponValue"
                              />

                              <span className="my-error">
                                {this.state.validated.errors.couponValue}
                              </span>
                            </div>
                          </div>

                          <div className="col-lg-12 mt-4">
                            <div className="form-group">
                              <div className="row">
                                <div className="col-lg-6">
                                  <label>{siteConstants.LABEL_MINIMUM_VALUE}</label>

                                  <input
                                    type="number"
                                    min="0"
                                    onChange={this.handleChange}
                                    placeholder={siteConstants.LABEL_MINIMUM_VALUE}
                                    className="form-control"
                                    name="productMinPrice"
                                    value={this.state.defaultData.productMinPrice}
                                  />

                                  <span className="my-error">
                                    {this.state.validated.errors.productMinPrice}
                                  </span>
                                </div>

                                <div className="col-lg-6">
                                  <div className="form-group">
                                    <label>{siteConstants.LABEL_PRODUCT_CATEGORY}</label>

                                    <MultiSelect
                                      options={this.state.allActiveCat}
                                      value={this.state.selectedCat}
                                      onChange={(e) => this.changeCategory(e)}
                                      labelledBy={"Select"}

                                    />
                                    <span className="my-error">
                                      {this.state.validated.errors.selectedCat}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>




                          <div className="col-lg-12">
                            <div className="form-group">
                              <label>{siteConstants.GEN_EXPIRY_DATE}</label>
                              <br />

                              <DatePicker
                                selected={this.state.selectedDate}
                                onChange={this.handleDateChange}
                                className="form-control"
                                popperPlacement='top-start'
                              />
                              <span className="my-error">
                                {this.state.validated.errors.selectedDate}
                              </span>
                            </div>
                          </div>

                          <div className="col-lg-12">
                            <div className="form-group">
                              {/* <button type="button" className="btn btn-primary" onClick={(event) => this.setState({ validated: this.props.funAdvertismentsAddUpdate(event, this.state) })}>{siteConstants.BTN_SAVE}</button>&nbsp; */}
                              <button
                                type="submit"
                                className="btn btn-primary"
                                onClick={this.handleSubmit}
                              >
                                {siteConstants.BTN_SAVE}
                              </button>
                              &nbsp;
                              <button
                                type="button"
                                className="btn btn-info"
                                onClick={() =>
                                  this.props.funPopupClose("editOpen")
                                }
                              >
                                {siteConstants.BTN_CANCEL}
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </DialogContent>
        </Dialog>
      );

    } else if (popupType === "") {
      return <div></div>;
    }
  }
}

//-- Here we are adding Reducer names, so it can be get data from reducers using store
function mapStateToProps(state) {
  const { language, getAllActiveCat } = state;
  return {
    language,
    getAllActiveCat
  };
}

const connectedEditPopup = connect(mapStateToProps)(EditPopup);
export default connectedEditPopup;
